import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["tab", "panel", "weeksLabel", "trainingsLabel"]

  switch(event) {
    event.preventDefault()
    const variantId = event.currentTarget.dataset.variantId
    this.activate(variantId)
  }

  activate(variantId) {
    this.tabTargets.forEach(tab => {
      const isActive = tab.dataset.variantId === variantId
      tab.classList.toggle("bg-slate-900", isActive)
      tab.classList.toggle("text-slate-50", isActive)
    })

    let active = null
    this.panelTargets.forEach(panel => {
      const isActive = panel.dataset.variantId === variantId
      panel.classList.toggle("d-none", !isActive)
      if (isActive) {
        active = panel
      }
    })

    if (active) {
      this.weeksLabelTargets.forEach(target => {
        target.textContent = active.dataset.weeksLabel
      })
      this.trainingsLabelTargets.forEach(target => {
        target.textContent = active.dataset.trainingsLabel
      })
    }
  }
}
